import React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import type { BoxT } from '@mentimeter/ragnar-ui/box';
import { Theme } from '@mentimeter/ragnar-ui/themes';
import {
  CONTENT_THEME,
  type CustomContentThemeType,
} from '@mentimeter/content-ui/Theme';
import { Pattern } from '../Pattern/Pattern';

export type SectionT = BoxT & CustomContentThemeType;

export const Section = React.forwardRef<HTMLDivElement, SectionT>(
  ({ theme, ...rest }, ref) => {
    const generalStyling: BoxT = {
      px: [4, 'space12', 6, 6],
      py: [4, 'space12', 'space18', 5],
      width: '100%',
      alignItems: 'center',
      as: 'section',
      overflow: 'hidden',
    };
    if (!theme) {
      return <Box ref={ref} {...generalStyling} {...rest} />;
    } else if (theme.colors.includes('pattern')) {
      return (
        <Pattern patternColor={theme.colors}>
          <Theme theme={CONTENT_THEME[theme.colors]}>
            <Box ref={ref} {...generalStyling} {...rest} />
          </Theme>
        </Pattern>
      );
    } else {
      return (
        <Theme theme={CONTENT_THEME[theme.colors]}>
          <Box bg="bg" ref={ref} {...generalStyling} {...rest} />
        </Theme>
      );
    }
  },
);
